import { List, AutoSizer, CellMeasurerCache, CellMeasurer } from 'react-virtualized';
import { useRef } from 'react';
import MImageCard from '../../molecules/MImageCard';
import { Center } from '@chakra-ui/layout';
import { Spinner } from '@chakra-ui/spinner';

const Card = ({ key, itemProps, style }: any) => (
    <div className="Card" style={{ ...style, width: '99%' }} key={key}>
        {itemProps?.key && <MImageCard {...itemProps} />}
    </div>
);

const DEFAULT_CARD_SIZE = 347;

const VirtualList = ({ items, isLoading, readonly }: { items: any[]; isLoading: boolean; readonly: boolean }) => {
    const cache = useRef(
        new CellMeasurerCache({
            fixedWidth: true,
            defaultHeight: 200,
        }),
    );

    const itemsPerRow = useRef(4);

    const containerRef = document.querySelector('.Container') as HTMLElement;
    const containerHeight = `calc(100vh - ${containerRef?.offsetTop + 25}px)`;

    const cardRef = document.querySelector('.pictureCard') as HTMLElement;
    const cardSize = cardRef?.clientWidth || DEFAULT_CARD_SIZE;

    const rowCount = Math.ceil(items.length / itemsPerRow.current);

    return (
        <div style={{ width: '100%', height: containerHeight, marginTop: '25px' }} className="Container">
            <AutoSizer>
                {({ width, height }) =>
                    isLoading ? (
                        <Center h="200px" w="100%" position="absolute">
                            <Spinner speed="0.65s" emptyColor="gray.200" color="blueMain" size="xl" />
                        </Center>
                    ) : (
                        <List
                            width={width}
                            height={height}
                            rowHeight={cache.current.rowHeight}
                            deferredMeasurementCache={cache.current}
                            rowCount={rowCount}
                            rowRenderer={({ key, index, style, parent }: any) => {
                                const newValue = Math.floor(width / cardSize);
                                itemsPerRow.current = newValue;
                                const currIndex = index * newValue;

                                return (
                                    <CellMeasurer
                                        key={key}
                                        cache={cache.current}
                                        parent={parent}
                                        columnIndex={0}
                                        rowIndex={index}
                                    >
                                        <div key={key} style={{ ...style, display: 'flex' }}>
                                            {Array.from({ length: newValue }).map((_arr, idx) => (
                                                <Card itemProps={items[currIndex + idx]} cardRef={cardRef} />
                                            ))}
                                        </div>
                                    </CellMeasurer>
                                );
                            }}
                        />
                    )
                }
            </AutoSizer>
        </div>
    );
};

export default VirtualList;
